<template>
  <div>
    <EditSingleEventForm
      :initial-form-data="singleEvent"
      :on-form-saved="onSingleEventSaved"
    />
  </div>
</template>

<script>
import EditSingleEventForm from '@/views/pages/locations/EditSingleEventForm'
import dayjs from 'dayjs'
import store from '@/store'
import { BButton } from 'bootstrap-vue'

export default {
  components: {
    EditSingleEventForm,
    BButton,
  },
  props: [
    'locationId',
  ],
  data() {
    return {
      singleEvent: {
        location_id: this.locationId,
        name: 'sample name',
        date: dayjs(new Date()).format('YYYY-MM-DD'),
        time: '12:00',
      },
    }
  },
  methods: {
    onSingleEventSaved(apiResponse) {
      const self = this
      store.dispatch('auth/getAuthUser')
        .then(() => {
          // after saving a new location, redirect to its edit for where all the other options like services are
          self.$router.push({
            name: 'edit-location',
            params: { id: apiResponse.data.location_id },
          })
        })
    },
  },
}
</script>
